import {
	CONTACT_BLOCKED_MESSAGE,
	isContactBlockedError,
} from '../../../utils/errors.js';

export class FeedbackFormView {
	constructor(state, options = {}) {
		this.state = state;
		this.options = options;
		this.element = null;
		this._isSubmitting = false;
	}

	render() {
		this.element = document.createElement('div');
		this.element.className = 'liveChat-view liveChat-feedback-view';
		this._renderForm();
		return this.element;
	}

	_renderForm() {
		this.element.innerHTML = `
			<div class="liveChat-feedback-header">
				<button class="sdk-btn-icon liveChat-feedback-back-btn" aria-label="Back">
					<iconify-icon icon="ph:arrow-left" width="20" height="20"></iconify-icon>
				</button>
				<span class="liveChat-feedback-title">Leave us feedback</span>
			</div>
			<div class="liveChat-feedback-body">
				<p class="liveChat-feedback-prompt">Share your thoughts with us. We read every message.</p>
				<div class="sdk-form-group">
					<label class="sdk-label">Title <span class="sdk-required">*</span></label>
					<input
						type="text"
						class="sdk-input liveChat-feedback-input"
						placeholder="Brief description of your feedback"
					/>
				</div>
				<div class="sdk-form-group">
					<label class="sdk-label">Message <span class="sdk-required">*</span></label>
					<textarea
						class="sdk-textarea liveChat-feedback-textarea"
						placeholder="Tell us what you think..."
					></textarea>
				</div>
				<span class="liveChat-feedback-error" style="display:none;"></span>
				<button class="sdk-btn-primary sdk-btn-block liveChat-feedback-submit">Send feedback</button>
			</div>
		`;
		this._attachEvents();
	}

	_renderThankYou() {
		this.element.innerHTML = `
			<div class="liveChat-feedback-header">
				<button class="sdk-btn-icon liveChat-feedback-back-btn" aria-label="Back">
					<iconify-icon icon="ph:arrow-left" width="20" height="20"></iconify-icon>
				</button>
				<span class="liveChat-feedback-title">Leave us feedback</span>
			</div>
			<div class="liveChat-feedback-thankyou">
				<div class="liveChat-feedback-success-icon">
					<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="#ffffff" stroke-width="24" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 256 256">
						<polyline points="216,72 96,192 40,136"/>
					</svg>
				</div>
				<h3>Thank you!</h3>
				<p>Your feedback has been submitted successfully.</p>
				<button class="liveChat-feedback-done-btn">Done</button>
			</div>
		`;
		this.element.querySelector('.liveChat-feedback-back-btn').addEventListener('click', () => {
			this.state.setView('home');
		});
		this.element.querySelector('.liveChat-feedback-done-btn').addEventListener('click', () => {
			this.state.setView('home');
		});
	}

	_attachEvents() {
		this.element.querySelector('.liveChat-feedback-back-btn').addEventListener('click', () => {
			this.state.setView('home');
		});

		const submitBtn = this.element.querySelector('.liveChat-feedback-submit');
		submitBtn.addEventListener('click', async () => {
			if (this._isSubmitting) return;
			const title = this.element.querySelector('.liveChat-feedback-input').value.trim();
			const message = this.element.querySelector('.liveChat-feedback-textarea').value.trim();
			await this._submit(title, message);
		});
	}

	_showError(text) {
		const errorEl = this.element.querySelector('.liveChat-feedback-error');
		if (errorEl) {
			errorEl.textContent = text;
			errorEl.style.display = 'block';
		}
	}

	_hideError() {
		const errorEl = this.element.querySelector('.liveChat-feedback-error');
		if (errorEl) {
			errorEl.style.display = 'none';
		}
	}

	async _submit(title, message) {
		this._hideError();

		if (!title) {
			this._showError('Please enter a title.');
			this.element.querySelector('.liveChat-feedback-input').focus();
			return;
		}

		if (!message) {
			this._showError('Please enter your feedback message.');
			this.element.querySelector('.liveChat-feedback-textarea').focus();
			return;
		}

		this._isSubmitting = true;
		const submitBtn = this.element.querySelector('.liveChat-feedback-submit');
		if (submitBtn) {
			submitBtn.disabled = true;
			submitBtn.textContent = 'Sending...';
		}

		try {
			if (this.options.onSubmitFeedback) {
				await this.options.onSubmitFeedback({ title, message });
			}
			this._renderThankYou();
		} catch (e) {
			console.warn('[FeedbackFormView] Submit error:', e);
			this._isSubmitting = false;
			const isBlocked = isContactBlockedError(e);
			this._showError(
				isBlocked
					? CONTACT_BLOCKED_MESSAGE
					: 'Failed to submit feedback. Please try again.'
			);
			if (submitBtn) {
				// A retry can't succeed while blocked, so leave it disabled.
				submitBtn.disabled = isBlocked;
				submitBtn.textContent = 'Send feedback';
			}
		}
	}

	destroy() {
		if (this.element && this.element.parentNode) {
			this.element.parentNode.removeChild(this.element);
		}
	}
}
